export async function logVideoView(
    lessonInstanceId,
    uniqueSeconds,
    totalSeconds,
    percentWatched
) {
    let url = `/api/lesson-instance/${lessonInstanceId}/view-event`;

    const response = await fetch(url, {
        method: "POSt",
        credentials: "same-origin",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            uniqueSeconds: uniqueSeconds,
            totalSeconds: totalSeconds,
            percentWatched: percentWatched,
        }),
        keepalive: true,
    });

    return response.json();
}

export function updateVideoView(
    lessonInstanceId,
    activityId,
    uniqueSeconds,
    totalSeconds,
    percentWatched
) {
    let url = `/api/lesson-instance/${lessonInstanceId}/view-event/${activityId}`;
    // use fetch instead of axios
    return fetch(url, {
        method: "PUT",
        credentials: "same-origin",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            uniqueSeconds: uniqueSeconds,
            totalSeconds: totalSeconds,
            percentWatched: percentWatched,
        }),
        keepalive: true,
    });
}

export function videoStats(instanceId, data) {
    let url = `/api/learn/lessons/${instanceId}/video-statistics`;
    // use fetch instead of axios
    return fetch(url, {
        method: "PUT",
        credentials: "same-origin",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
        keepalive: true,
    });
}
